import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useQuery } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import { elGray } from '../../styles/colors';

import FeesNotApprovedReport from './FeesNotApprovedReport';
import { PAST_SALES } from 'app/src/components/Sales/queries';

const Reports = () => {
  const { data, loading, error } = useQuery(PAST_SALES);

  if (loading || !data) return <DataState.Loading />;
  if (error) return <DataState.Error error={error} />;

  return (
    <View style={styles.container}>
      <FeesNotApprovedReport data={data} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    marginTop: 20,
    backgroundColor: elGray,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
  },
});

export const cardStyles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 10,
    minWidth: 600,
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  note: {
    color: 'red',
    fontWeight: 800,
    marginBottom: 10,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
  },
  select: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 5,
    marginBottom: 10,
    paddingHorizontal: 5,
    height: 25,
  },
});

export default Reports;
